// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__277XN","inputWrap":"styles_inputWrap__1Hza4","input":"styles_input__2aHYT"};